import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import { node, string } from "prop-types";

import * as S from "./styled";

const LoadingIndicator = ({ children, className }) => (
  <S.LoadingContainer className={className}>
    <S.Spinner />
    {children}
  </S.LoadingContainer>
);

LoadingIndicator.propTypes = {
  className: string,
  children: node
};

LoadingIndicator.defaultProps = {
  className: "",
  children: <Text type="sm">Loading</Text>
};

export default LoadingIndicator;
